import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import firebase from "firebase";
import { useDocument } from "react-firebase-hooks/firestore";
import { Button, Modal, Form, Card } from "react-bootstrap";
import {
  setSixPathHeader,
  setSixPathRows,
} from "../../../../store/actions/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddLinkModal from "./common/AddLinkModal";
import DisplayLink from "./common/DisplayLink";

function SixPathTable(props) {
  const {
    old,
    setSixPathHeader,
    setSixPathRows,
    sixPathRows,
    sixPathHeaders,
    graphId,
    currentEvent,
    darkTheme,
    appId,
    sectionIdList,
    isAdmin,
  } = props;

  const PATH_NAME = old ? "six_path" : "six_path_new";

  const [path, setPath] = useState(0);
  const [pathName, setPathName] = useState("");
  const [pathDetails, setPathDetails] = useState(null);
  const [addRowModal, setAddRowModal] = useState(false);
  const [newRowValue, setNewRowValue] = useState({});
  const [editSelectedValue, setEditSelectedValue] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [showProTips, setShowProTips] = useState(true);
  const [showAddLinkModal, setShowAddLinkModal] = useState(false);
  const linksDataList = useSelector((state) => state.links);

  const [headDoc, headDocLoading, headDocError] = useDocument(
    firebase
      .firestore()
      .doc(
        `events/${
          currentEvent?.id
        }/bboa/${graphId}/${PATH_NAME}/${path.toString()}`
      )
  );

  useEffect(() => {
    // firebase
    //   .firestore()
    //   .doc(
    //     `events/${
    //       currentEvent?.id
    //     }/bboa/${graphId}/${PATH_NAME}/${path.toString()}`
    //   )
    //   .get()
    //   .then((headDoc) => {
    if (headDoc?.exists) {
      setSixPathHeader(headDoc?.data().head);
      setPathName(headDoc?.data().name);
      setPathDetails({
        ...headDoc?.data(),
        id: headDoc.id,
      });
    }
    // });
  }, [path, PATH_NAME, headDoc]);

  useEffect(() => {
    firebase
      .firestore()
      .collection(
        `events/${
          currentEvent?.id
        }/bboa/${graphId}/${PATH_NAME}/${path.toString()}/rows`
      )
      .onSnapshot((snapshot) => {
        let arr = [];
        snapshot.forEach((item) => {
          arr.push({ ...item.data(), id: item.id });
        });
        setSixPathRows(arr);
      });
  }, [path, pathName]);

  // const addNewRowValuesHandler = (e) => {
  //   e.preventDefault();
  //   console.log("ML SIX Paths ==> ",newRowValue, path, sixPathRows.length, "values")
  //   if (path >= 0 && sixPathRows.length >= 0) {
  //     firebase
  //       .firestore()
  //       .collection(
  //         `events/${
  //           currentEvent?.id
  //         }/bboa/${graphId}/${PATH_NAME}/${path.toString()}/rows`
  //       )
  //       .doc(`${sixPathRows.length}`)
  //       .set({
  //         ...newRowValue,
  //       });
  //     setAddRowModal(false);
  //     setNewRowValue({});
  //   }
  // };

  const addNewRowValuesHandler = async (e) => {
    e.preventDefault();

    if (path >= 0 && sixPathRows.length >= 0) {
      // Get the reference to the Firestore collection
      const collectionRef = firebase
        .firestore()
        .collection(
          `events/${
            currentEvent?.id
          }/bboa/${graphId}/${PATH_NAME}/${path.toString()}/rows`
        );

      // Retrieve all document IDs in the collection
      const snapshot = await collectionRef.get();
      const existingIds = snapshot.docs.map((doc) => parseInt(doc.id));

      console.log("Exsisting Ids ML ==> ", existingIds);

      // Find the maximum ID and add 1
      const validNumbers = existingIds.filter(Number.isFinite);
      const maxId = validNumbers.length > 0 ? Math.max(...validNumbers) : 0;
      console.log("Max Id ML ==> ", maxId);

      const newId = maxId + 1;
      console.log("new Id ML ==> ", newId);

      // Add a new document with the new ID
      await collectionRef.doc(`${newId}`).set({
        ...newRowValue,
      });

      setAddRowModal(false);
      setNewRowValue({});
    }
  };

  const updateValueHandler = (e) => {
    e.preventDefault();
    console.log(editSelectedValue);
    if (editSelectedValue) {
      firebase
        .firestore()
        .collection(
          `events/${
            currentEvent?.id
          }/bboa/${graphId}/${PATH_NAME}/${path.toString()}/rows`
        )
        .doc(`${editSelectedValue.rowId}`)
        .set(
          {
            [editSelectedValue.headId]: editSelectedValue.value,
          },
          {
            merge: true,
          }
        );
      setShowEditModal(false);
      setEditSelectedValue({});
    }
  };

  const deleteCurrentRow = (value) => {
    console.log(value);
    if (value) {
      firebase
        .firestore()
        .collection(
          `events/${
            currentEvent?.id
          }/bboa/${graphId}/${PATH_NAME}/${path.toString()}/rows`
        )
        .doc(`${value.rowId}`)
        .delete()
        .then(() => {
          toast.success("You have successfully deleted row", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          });
        })
        .catch((error) => {
          toast.error("Something went wrong.", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          });
        });
      setShowEditModal(false);
    }
  };

  console.log("SIX PATH RAWS ML ===> ", sixPathRows);

  return (
    <Card
      className={
        darkTheme
          ? "bg-dark shadow-sm border border-dark mb-3"
          : "bg-white shadow-sm border border-light mb-3"
      }
    >
      <Card.Header>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h5 className="mb-0 text-uppercase">
              {old ? "OLD: SIX-PATH DESCRIPTION" : "6. SIX-PATH DESCRIPTION"}
            </h5>

            {isAdmin ? (
              <DisplayLink
                project_id={appId}
                section_id={sectionIdList[5]}
                isAdmin={isAdmin}
              />
            ) : null}
          </div>

          {isAdmin ? (
            <Button
              size="md"
              className="text-uppercase mr-4"
              onClick={() => setShowAddLinkModal(true)}
              disabled={linksDataList.find(
                (t) => t.section_id === sectionIdList[5]
              )}
              variant="success"
            >
              AI
            </Button>
          ) : linksDataList.find((t) => t.section_id === sectionIdList[5]) ? (
            <a
              href={
                linksDataList.find((t) => t.section_id === sectionIdList[5])
                  ?.url
              }
              target="_blank"
              rel="noopener"
              style={{ textDecoration: "none" }}
            >
              <Button
                size="md"
                className="text-uppercase mr-4"
                variant="success"
              >
                AI
              </Button>
            </a>
          ) : (
            <Button
              size="md"
              className="text-uppercase mr-4"
              variant="success"
              disabled
            >
              AI
            </Button>
          )}
        </div>
      </Card.Header>
      <Card.Body>
        <div className="d-flex align-items-center mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            {pathDetails?.logo && (
              <div className="mr-2">
                <img
                  className="img-fluid"
                  src={`https://igesia-static-1bt.s3.amazonaws.com/images/bboa/${pathDetails.logo}.png`}
                  style={{
                    height: 40,
                    width: 40,
                  }}
                />
              </div>
            )}
            <div>
              <h6 className="text-uppercase mb-0">{pathName && pathName}</h6>
              {pathDetails?.definition && (
                <p className="mb-0">{pathDetails.definition}</p>
              )}
            </div>
          </div>
          <div className="d-flex">
            <Button
              variant="light"
              size="sm"
              className="mr-2 text-uppercase"
              onClick={() => {
                if (path > 0) {
                  setPath(path - 1);
                  setSixPathRows([]);
                  setSixPathHeader([]);
                } else {
                  return;
                }
              }}
              disabled={path > 0 ? false : true}
              title={path > 0 ? `Go to previous path` : `No previous path`}
            >
              {`<< Previous`}
            </Button>

            <Button
              size="sm"
              className="mr-2 button-muted text-uppercase"
              onClick={() => {
                if (path < 5) {
                  setPath(path + 1);
                  setSixPathRows([]);
                  setSixPathHeader([]);
                } else {
                  return;
                }
              }}
              disabled={path < 5 ? false : true}
              title={path < 5 ? `Go to next path` : `No next path`}
            >
              {"Next >>"}
            </Button>
          </div>
        </div>
        <table class="table table-striped">
          <thead className={darkTheme ? "thead-light" : "thead-dark"}>
            <tr>
              {sixPathHeaders?.map((item) => (
                <th scope="col" key={item.id}>
                  {item.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="w-100">
            {sixPathRows?.length > 0 ? (
              sixPathRows?.map((rowData) => {
                return (
                  <tr>
                    {sixPathHeaders?.map((headData, index) => {
                      return (
                        <td
                          className={
                            darkTheme
                              ? " border border-light"
                              : " border border-dark"
                          }
                          data-theme={darkTheme ? "dark" : "light"}
                          onClick={(e) => {
                            // console.log( headData.id, rowData.id, rowData[headData.id])
                            setEditSelectedValue({
                              rowId: rowData.id,
                              headId: headData.id.toString(),
                              value: rowData[headData.id],
                            });
                            setShowEditModal(true);
                          }}
                        >
                          {rowData[headData.id]}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <div className="py-2">
                <p className={darkTheme ? "mb-0 text-light" : "mb-0 text-dark"}>
                  No rows added yet
                </p>
              </div>
            )}
          </tbody>
        </table>
        <div className="w-100">
          <Button
            className="text-uppercase w-100"
            size="sm"
            onClick={() => setAddRowModal(true)}
          >
            Add Row
          </Button>
        </div>
        <>
          <AddLinkModal
            show={showAddLinkModal}
            project_id={appId}
            section_id={sectionIdList[5]}
            onClose={() => setShowAddLinkModal(false)}
            onSubmit={null}
          />

          <Modal
            centered
            show={addRowModal}
            onHide={() => setAddRowModal(false)}
          >
            <Modal.Header data-theme={darkTheme ? "dark" : "light"} closeButton>
              <div className="d-flex align-items-center flex-grow-1">
                {pathDetails?.logo && (
                  <div className="mr-2">
                    <img
                      className="img-fluid"
                      src={`https://igesia-static-1bt.s3.amazonaws.com/images/bboa/${pathDetails.logo}.png`}
                      style={{
                        height: 40,
                        width: 40,
                      }}
                    />
                  </div>
                )}
                <div>
                  <h5 className="text-uppercase mb-0">
                    {pathName && pathName}
                  </h5>
                  {pathDetails?.definition && (
                    <p className="mb-0">{pathDetails.definition}</p>
                  )}
                </div>
              </div>
            </Modal.Header>
            <Modal.Body data-theme={darkTheme ? "dark" : "light"}>
              <Form onSubmit={(e) => addNewRowValuesHandler(e)}>
                {sixPathHeaders?.map((item, index) => {
                  return (
                    <Form.Group className="mb-3" key={index}>
                      <Form.Label>{item.name}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter your answer"
                        value={newRowValue[item.id]}
                        onChange={(e) =>
                          setNewRowValue((prev) => {
                            const newState = {
                              ...prev,
                              [item.id]: e.target.value,
                            };
                            return newState;
                          })
                        }
                      />
                    </Form.Group>
                  );
                })}
              </Form>
            </Modal.Body>
            <Modal.Footer data-theme={darkTheme ? "dark" : "light"}>
              {Object.keys(newRowValue).length === 0 ? (
                <Button
                  variant="secondary"
                  onClick={() => setAddRowModal(false)}
                >
                  Close
                </Button>
              ) : (
                <Button
                  variant="secondary"
                  onClick={() => {
                    setNewRowValue({});
                    setAddRowModal(false);
                  }}
                >
                  Discard
                </Button>
              )}

              <Button
                variant="primary"
                onClick={(e) => addNewRowValuesHandler(e)}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </>
        <>
          <Modal
            centered
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
          >
            <Modal.Header data-theme={darkTheme ? "dark" : "light"} closeButton>
              <Modal.Title>Edit</Modal.Title>
            </Modal.Header>
            <Modal.Body data-theme={darkTheme ? "dark" : "light"}>
              <Form onSubmit={(e) => updateValueHandler(e)}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Control
                    type="text"
                    placeholder="Enter value"
                    value={editSelectedValue?.value}
                    onChange={(e) =>
                      setEditSelectedValue((prev) => {
                        const newState = { ...prev, value: e.target.value };
                        return newState;
                      })
                    }
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer data-theme={darkTheme ? "dark" : "light"}>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowEditModal(false)}
              >
                Close
              </Button>
              <Button
                size="sm"
                variant="primary"
                onClick={(e) => updateValueHandler(e)}
              >
                Save
              </Button>
              {parseInt(editSelectedValue?.rowId) <
              sixPathRows?.length - 1 ? null : (
                <Button
                  onClick={() => {
                    deleteCurrentRow(editSelectedValue);
                  }}
                  size="sm"
                  variant="danger"
                  disabled={
                    parseInt(editSelectedValue?.rowId) < sixPathRows?.length - 1
                  }
                  title={
                    parseInt(editSelectedValue?.rowId) < sixPathRows?.length - 1
                      ? "Only last row can be deleted"
                      : ""
                  }
                >
                  <div>
                    <FontAwesomeIcon size="sm" icon={faTrash} /> Delete row
                  </div>
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </>
      </Card.Body>
      <Card.Footer>
        <div className="d-flex align-items-center">
          <p className="mb-0 text-uppercase small">
            <b>Pro tips</b>
          </p>
          <p
            style={{ cursor: "pointer" }}
            className="mb-0 text-uppercase small text-muted ml-2"
            onClick={() => setShowProTips((prev) => !prev)}
            title={
              showProTips ? "Click to hide pro tips" : "Click to show pro tips"
            }
          >
            <b>({showProTips ? "Hide" : "Show"})</b>
          </p>
        </div>
        <ol
          className={showProTips ? "px-3 mb-1 pb-1" : "px-3 mb-1 pb-1 d-none"}
        >
          <li>
            <small>
              Add a new row by clicking on <b>Add Row</b> button under the
              table.
            </small>
          </li>
          <li>
            <small>
              Navigate the 6 paths using the <b>Next</b> and <b>Previous</b>{" "}
              buttons on top right.
            </small>
          </li>
        </ol>
      </Card.Footer>
    </Card>
  );
}

export default connect(
  (state) => ({
    graphId: state.graphId,
    sixPathRows: state.sixPathRows,
    sixPathHeaders: state.sixPathHeaders,
    currentEvent: state.currentEvent,
    darkTheme: state.darkTheme,
  }),
  {
    setSixPathHeader,
    setSixPathRows,
  }
)(SixPathTable);
